// extracted by mini-css-extract-plugin
export var content = "index-module--content--41BM0";
export var schoolCol = "index-module--school-col--iXwLl";
export var programColLeft = "index-module--program-col-left--y8bwQ";
export var buttonColRight = "index-module--button-col-right--QsYVv";
export var displayLinebreaks = "index-module--display-linebreaks--04tC+";